import React from "react";
import {Route, Routes} from "react-router-dom";
import {SubscriptionCreate} from "./SubscriptionCreate";
import {SubscriptionList} from "./SubscriptionList";

export function Subscriptions() {
	return (
		<Routes>
			<Route index element={<SubscriptionList />} />
			<Route path="new" element={<SubscriptionCreate />} />
		</Routes>
	);
}
